<template>  
  <div class="container-fluid">
    <div ref="widthContainer" class="row justify-content-center">
      <div class="col-12">
        <SinglePregunta :pregunta="pregunta" />
      </div>
    </div>   
  </div>
</template>

<style lang="scss">
  body {
    background: #e3e3e352;
  }
</style>

<script>

import IframeResizer from '@/utils/iframe-resizer'
import { mapState } from 'vuex'
import { find } from 'lodash'

import SinglePregunta from '@/components/SinglePregunta'


export default {
  name: 'SecondHome',
  components: {
    SinglePregunta

  },
  data() {
    return {
      preguntaItem: {},
      widthContainer: 0
    }
  },
  mounted () {
    IframeResizer.create()
    this.widthContainer = this.$refs['widthContainer'].offsetWidth
    window.addEventListener('resize', () => {
      this.widthContainer = this.$refs['widthContainer'].offsetWidth
		})
  },
  computed: {
    ...mapState({
      data_preguntas: state => state.encuesta.data_preguntas,     
    }),
    pregunta() {
      let id = this.$route.params.id_pregunta
      return find(this.data_preguntas, ['id', id])
    }
  }
}
</script>